<div class="button-toggle-container">
  <b>{{ 'customer-spaces.user-management.customer-space' | translate }}</b>
  <mat-button-toggle-group [formControl]="control" class="language-toggle">
    <mat-button-toggle [value]="true">
      {{ customerSpaceName$ | async | shorten:24 }}
    </mat-button-toggle>
    <mat-button-toggle [value]="false">
      {{ 'customer-spaces.user-management.all' | translate }}
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>